import { render, staticRenderFns } from "./Goldershill.vue?vue&type=template&id=479f9654&"
import script from "./Goldershill.vue?vue&type=script&lang=js&"
export * from "./Goldershill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports